import { Box, Typography } from "@mui/material";
import React from "react";
import { useComponentSelection } from "../../Hooks/useComponentSelection";
import { IComponent } from "../../Models/IComponent";
import IComponentProps from "../IComponentProps";

const UnknownComponent: React.FC<IComponentProps<IComponent>> = ({ component, componentPath = [] }) => {
  const selectionProps = useComponentSelection({ component, componentPath });

  return (
    <Box
      {...selectionProps}
      sx={{
        border: "1px dashed",
        borderColor: "warning.main",
        borderRadius: 1,
        px: 1,
        py: 0.5,
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
      }}
    >
      <Typography variant="caption" color="warning.main">
        Unknown: {component.Type}
      </Typography>
    </Box>
  );
};

export default UnknownComponent;
